import api from './api';

const notificationService = {
  async list() {
    const response = await api.get('/notifications');
    return response.data;
  },

  async unreadCount() {
    const response = await api.get('/notifications/unread-count');
    return response.data;
  },

  async markAsRead(id) {
    const response = await api.post(`/notifications/${id}/read`);
    return response.data;
  },

  async markAllAsRead() {
    const response = await api.post('/notifications/read-all');
    return response.data;
  },

  async getKardexRecalculateRun(id) {
    const response = await api.get(`/kardex-recalculate-runs/${id}`);
    return response.data;
  },

  async listKardexRecalculateRuns(params = {}) {
    const response = await api.get('/kardex-recalculate-runs', { params });
    return response.data;
  },
};

export default notificationService;
